import { http } from '../services';

class AreaService {
    areaForm() {
        return http.get('/areas/form');
    }

    async getAreas(subevento) {
        return http.get('/areas', { subevento });
    }

    async getAreasCoordenador(subevento) {
        return http.get('/areas-do-coordenador', { subevento });
    }

    getArea(codigo) {
        return http.get(`/areas/${codigo}`);
    }

    save(area) {
        return http.post('/areas', area);
    }

    update(area) {
        return http.put('/areas', area);
    }

    delete(area) {
        return http.delete('/areas', area);
    }
}

const areaService = new AreaService();
export default areaService;
